import { SEOSection } from '@/components';
import { capitalize } from '@/utils';
import { ContentTypeName } from '@/constants';
import { useMyParcelsContext } from '@/modules/pmt/context';

export const PMTSeoSection = () => {
  const { pmtPageData } = useMyParcelsContext();
  const foundSeoSection = pmtPageData?.sectionList?.find(
    (section: any) => capitalize(section.__typename) === ContentTypeName.SeoSection,
  );

  if (!foundSeoSection) {
    return null;
  }

  return <SEOSection {...foundSeoSection} />;
};
